module.exports = __webpack_public_path__ + "media/images/imdb-icon-white-7c67c8e40c459228a87f27c3b8757f54.png";